<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import moment from 'moment';
import DataTable from 'datatables.net-vue3';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";

export default {
    page: {
        title: "Aging Report",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Aging Report",
            items: [
                {
                text: "Aging Report",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            aging_listing:[],
            aging_summary_listing:[],
            loadingDetail:false,
            loadingRoles:true,
            date: '',
            dtKey:0,
            dtKey2:0,
            key_search:'',
            days_30: '0.00',
            days_60: '0.00',
            days_90: '0.00',
            days_120: '0.00',
            days_above_120: '0.00',        
            total_aging_outstanding: '0.00',        
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        formatCurrency(value) {
            let val = (value/1).toFixed(2)
            return this.getCurrency() +" " +val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        downloadExcel: function () {
            this.loadingDetail=true;
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/agingListingExport', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Aging Report.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getAgingListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/agingListing')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.aging_listing = response.data;
                    console.log(this.aging_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getAgingSummaryListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/agingSummaryListing')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.aging_summary_listing = response.data;
                    this.days_30 = this.aging_summary_listing[0].days_0_30;
                    this.days_60 = this.aging_summary_listing[0].days_31_60;
                    this.days_90 = this.aging_summary_listing[0].days_61_90;
                    this.days_120 = this.aging_summary_listing[0].days_91_120;
                    this.days_above_120 = this.aging_summary_listing[0].more_than_120;
                    this.total_aging_outstanding = this.aging_summary_listing[0].total_aging_outstanding;
                    this.dtKey +=1;
                    console.log(this.aging_summary_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        searchAgingForm(e)
        {
            this.loadingRoles=true,
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/searchAging', posting_)
            .then(response => {
                if (response) {
                    this.aging_listing = response.data;
                    this.dtKey2 +=1;
                    console.log(this.aging_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
            this.loadingRoles=false;
        },

        resetForm: function () { 
            this.date = ''; 
            this.key_search = '';
            this.loadingRoles=true;
            this.getAgingListing();
        },
        getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },
    },

    components: {
        Layout,
        PageHeader,
        flatPickr,
        DataTable,
    },

    mounted() {
        this.getAgingSummaryListing();
        this.getAgingListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Aging Report</h5>
                        </div>
                    </div>                
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="searchAgingForm">
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search for Customer Name, Reference Number" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-xl-6 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-12">
                                <div class="search-box"><i class="ri-search-line search-icon"></i>
                                    <flat-pickr v-model="date" placeholder="Select Date Range" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click="resetForm" class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                <!--end row-->
                </form>
            </div>
             <div class="card-header border-bottom-dashed">
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button @click="downloadExcel()" class="btn btn-success w-100"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <h6>Total Outstanding Summary</h6>
                                <div class="table-responsive pb-4">
                                <DataTable :options="{lengthChange: false,searching: false, ordering: false, paging: false, info: false}" :key="dtKey" class="table table-striped table-nowrap mb-5" id="example"> 
                                     <thead class="table-info">
                                        <tr>              
                                            <th scope="col">Total Outstanding</th>
                                            <th scope="col">0 - 30 Days</th>
                                            <th scope="col">31 - 60 Days</th>
                                            <th scope="col">61 - 90 Days</th>           
                                            <th scope="col">91 - 120 Days</th>           
                                            <th scope="col">> 120 Days</th>           
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr class="content">
                                            <td>{{ formatCurrency(total_aging_outstanding) }}</td>                              
                                            <td>{{ formatCurrency(days_30) }}</td>
                                            <td>{{ formatCurrency(days_60) }}</td>
                                            <td>{{ formatCurrency(days_90) }}</td>                                      
                                            <td>{{ formatCurrency(days_120) }}</td>                              
                                            <td>{{ formatCurrency(days_above_120) }}</td>                              
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                                <h6>Aging Summary</h6>
                                <div class="table-responsive">
                                <DataTable v-if="aging_listing.length > 0" :options="{lengthChange: false,searching: false, ordering: false}" :key="dtKey2" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>        
                                            <th scope="col">Reference Number</th>  
                                            <th scope="col">Customer Name</th>  
                                            <th scope="col">Total Outstanding</th>           
                                            <th scope="col"><router-link :to="'/ar/reports/aging-report-details/1'" class="fw-medium link-secondary"><b>0 - 30 Days</b></router-link></th>
                                            <th scope="col"><router-link :to="'/ar/reports/aging-report-details/2'" class="fw-medium link-secondary"><b>31 - 60 Days</b></router-link></th>
                                            <th scope="col"><router-link :to="'/ar/reports/aging-report-details/3'" class="fw-medium link-secondary"><b>61 - 90 Days</b></router-link></th>           
                                            <th scope="col"><router-link :to="'/ar/reports/aging-report-details/4'" class="fw-medium link-secondary"><b>91 - 120 Days</b></router-link></th>           
                                            <th scope="col"><router-link :to="'/ar/reports/aging-report-details/5'" class="fw-medium link-secondary"><b>> 120 Days</b></router-link></th>           
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in aging_listing" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.curlec_refno }}</td>
                                            <td><router-link :to="'/ar/reports/aging-report-customer/'+item.customer_id" class="fw-medium link-secondary">{{ item.name_as_per_nric }}</router-link></td> 
                                            <td>{{ formatCurrency(item.total_outstanding) }}</td>                              
                                            <td>{{ formatCurrency(item.days_0_30) }}</td>
                                            <td>{{ formatCurrency(item.days_31_60) }}</td>
                                            <td>{{ formatCurrency(item.days_61_90) }}</td>                                      
                                            <td>{{ formatCurrency(item.days_91_120) }}</td>                              
                                            <td>{{ formatCurrency(item.more_than_120) }}</td>                              
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>